module.exports = __webpack_public_path__ + "static/media/ico-back.0bc09a9a.svg";